var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFrustrated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3023 52.8569C41.6324 52.8569 51.6279 42.6234 51.6279 29.9997C51.6279 17.3761 41.6324 7.14258 29.3023 7.14258C16.9723 7.14258 6.97673 17.3761 6.97673 29.9997C6.97673 42.6234 16.9723 52.8569 29.3023 52.8569Z",
    fill: "url(#paint0_radial_4760_27447)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.3023 52.8569C41.6324 52.8569 51.6279 42.6234 51.6279 29.9997C51.6279 17.3761 41.6324 7.14258 29.3023 7.14258C16.9723 7.14258 6.97673 17.3761 6.97673 29.9997C6.97673 42.6234 16.9723 52.8569 29.3023 52.8569Z",
    fill: "url(#paint1_radial_4760_27447)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5722 19.8426C24.6698 18.7425 23.7769 17.9711 22.1164 17.814C20.7071 17.6711 17.5256 18.3282 15.0838 21.4854C14.6373 22.0711 15.2094 22.4711 15.628 22.0997C17.0652 20.8569 20.735 19.4425 23.4419 20.0711C24.5303 20.3283 24.5722 19.8426 24.5722 19.8426Z",
    fill: "url(#paint2_linear_4760_27447)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0184 30.9716C23.2052 30.9716 24.1672 29.4814 24.1672 27.643C24.1672 25.8047 23.2052 24.3145 22.0184 24.3145C20.8316 24.3145 19.8695 25.8047 19.8695 27.643C19.8695 29.4814 20.8316 30.9716 22.0184 30.9716Z",
    fill: "url(#paint3_radial_4760_27447)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0184 25.4432C22.9393 25.4432 23.7487 26.2718 24.1672 27.486C24.1393 25.686 23.1905 24.2432 22.0184 24.2432C20.8463 24.2432 19.8974 25.686 19.8695 27.486C20.2882 26.2718 21.0835 25.4432 22.0184 25.4432Z",
    fill: "url(#paint4_linear_4760_27447)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5862 30.9716C37.7729 30.9716 38.735 29.4814 38.735 27.643C38.735 25.8047 37.7729 24.3145 36.5862 24.3145C35.3993 24.3145 34.4373 25.8047 34.4373 27.643C34.4373 29.4814 35.3993 30.9716 36.5862 30.9716Z",
    fill: "url(#paint5_radial_4760_27447)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5862 25.5291C35.6652 25.5291 34.8559 26.3577 34.4373 27.572C34.4652 25.772 35.4141 24.3291 36.5862 24.3291C37.7583 24.3291 38.7071 25.772 38.735 27.572C38.3164 26.3577 37.521 25.5291 36.5862 25.5291Z",
    fill: "url(#paint6_linear_4760_27447)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2046 45.0284C32.9162 45.0284 36.4185 45.8284 38.2046 45.8284C39.9906 45.8284 41.5674 44.7713 42.7255 40.957C44.2883 35.8284 37.8697 35.2998 29.1906 35.2998C20.5115 35.2998 14.0929 35.8284 15.6557 40.957C16.8139 44.7713 18.3906 45.8284 20.1767 45.8284C21.9906 45.8141 25.4929 45.0284 29.2046 45.0284Z",
    fill: "url(#paint7_radial_4760_27447)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2048 35.2861C20.5258 35.2861 14.1072 35.8147 15.6699 40.9433C16.8281 44.7576 18.4049 45.8147 20.1909 45.8147C20.1909 45.8147 16.4793 44.4433 17.7072 41.6719C18.9351 38.9005 29.2048 36.4147 29.2048 36.4147C29.2048 36.4147 39.4606 38.9005 40.7025 41.6719C41.9444 44.4433 38.2188 45.8147 38.2188 45.8147C40.0049 45.8147 41.5816 44.7576 42.7397 40.9433C44.3026 35.8147 37.884 35.2861 29.2048 35.2861Z",
    fill: "url(#paint8_linear_4760_27447)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2044 43.8859C31.4648 43.8859 33.6416 44.1716 35.3858 44.4002C36.5439 44.5573 37.5486 44.6858 38.2044 44.6858C38.302 44.6858 38.3997 44.7002 38.5114 44.7002C40.5486 44.7002 41.037 41.3144 40.4927 41.3144C40.4927 41.3144 41.8323 39.4287 40.7439 37.8144C38.3439 36.4287 32.5253 36.4287 29.2044 36.4287C25.8835 36.4287 20.0648 36.4287 17.6648 37.8144C16.5765 39.443 17.916 41.3144 17.916 41.3144C17.3718 41.3144 17.8602 44.7002 19.8974 44.7002C20.009 44.6858 20.1067 44.6858 20.2044 44.6858C20.8742 44.6858 21.8649 44.5573 23.023 44.4002C24.7672 44.1573 26.9439 43.8859 29.2044 43.8859Z",
    fill: "url(#paint9_radial_4760_27447)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8882 41.6427C25.3952 39.8999 33.1951 39.9285 40.6882 41.7142C40.6742 41.5142 40.6184 41.3713 40.5346 41.3285L40.4789 41.3142C40.4789 41.3142 36.7253 39.957 29.2882 39.957C21.851 39.957 17.9021 41.3142 17.9021 41.3142C17.7905 41.3142 17.7207 41.457 17.7067 41.6856L17.8882 41.6427Z",
    fill: "#99AFB3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0327 19.7566C33.9351 18.6566 34.8281 17.8852 36.4886 17.728C37.8979 17.5852 41.0793 18.2423 43.5211 21.3994C43.9676 21.9852 43.3956 22.3852 42.9769 22.0138C41.5397 20.7709 37.87 19.3566 35.163 19.9852C34.0746 20.2423 34.0327 19.7566 34.0327 19.7566Z",
    fill: "url(#paint10_linear_4760_27447)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4760_27447",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9097 20.7365) scale(26.9329 27.5742)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4760_27447",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9097 20.7365) scale(21.1893 21.6938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4760_27447",
    x1: 19.7116,
    y1: 21.2125,
    x2: 19.9903,
    y2: 18.3371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4760_27447",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.361 27.7308) rotate(74.2105) scale(3.2238 2.04452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4760_27447",
    x1: 22.0131,
    y1: 24.3017,
    x2: 22.0131,
    y2: 27.4038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4760_27447",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.94 27.7313) rotate(74.2105) scale(3.22381 2.04452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4760_27447",
    x1: 36.5914,
    y1: 24.3836,
    x2: 36.5914,
    y2: 27.4856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_4760_27447",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.2033 40.5475) scale(10.3931 10.6405)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4760_27447",
    x1: 15.4357,
    y1: 40.5481,
    x2: 42.9713,
    y2: 40.5481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_4760_27447",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.2031 40.5584) rotate(180) scale(18.8737 19.3231)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9BCBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4760_27447",
    x1: 38.8962,
    y1: 21.1314,
    x2: 38.6176,
    y2: 18.2558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFrustrated);
export default __webpack_public_path__ + "static/media/icon_frustrated.4fa3d763c9f6c663dff66281d1efe26d.svg";
export { ForwardRef as ReactComponent };